export class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.onCartRequestEnd = this.onCartRequestEnd.bind(this);
    this.syncMinQtyCheckoutLock = this.syncMinQtyCheckoutLock.bind(this);
  }

  connectedCallback() {
    document.addEventListener('liquid-ajax-cart:request-end', this.onCartRequestEnd);
    document.addEventListener('liquid-ajax-cart:init', this.syncMinQtyCheckoutLock);
    requestAnimationFrame(() => this.syncMinQtyCheckoutLock());
  }

  disconnectedCallback() {
    document.removeEventListener('liquid-ajax-cart:request-end', this.onCartRequestEnd);
    document.removeEventListener('liquid-ajax-cart:init', this.syncMinQtyCheckoutLock);
  }

  /**
   * `{% render %}` isolates snippet scope, so we cannot read Liquid's
   * `has_minimum_quantity_issues` in the parent. Mirror cart page behavior by
   * disabling checkout when min-qty notices are present in the drawer DOM.
   */
  syncMinQtyCheckoutLock() {
    const btn = this.querySelector('.cart-drawer__checkout[name="checkout"]');
    if (!btn) return;
    const hasIssues = Boolean(this.querySelector('.cart-item__min-qty-notice'));
    btn.disabled = hasIssues;
  }

  onCartRequestEnd(event) {
    const { requestState } = event.detail || {};
    if (requestState?.requestType === 'add' && requestState?.responseData?.ok) {
      window.dispatchEvent(new CustomEvent('cart-open'));
    }
    this.syncMinQtyCheckoutLock();
  }
}

if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', CartDrawer);
}


